/**
 * TimelineActiveFilters Component
 *
 * Displays active filters as badges with a clear all button.
 */

import React from "react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { X } from "lucide-react";

interface TimelineActiveFiltersProps {
  activeFilterCount: number;
  activeFilterLabels: string[];
  onClearAll: () => void;
}

const TimelineActiveFiltersBase: React.FC<TimelineActiveFiltersProps> = ({
  activeFilterCount,
  activeFilterLabels,
  onClearAll,
}) => {
  if (activeFilterCount === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap items-center gap-2 px-1">
      <span className="text-sm text-gray-600 font-medium">Active filters:</span>
      {activeFilterLabels.map((label, index) => (
        <Badge
          key={index}
          variant="secondary"
          className="text-xs bg-blue-100 text-blue-800"
        >
          {label}
        </Badge>
      ))}
      <Button
        variant="ghost"
        size="sm"
        onClick={onClearAll}
        className="h-6 px-2 text-xs text-red-600 hover:bg-red-50"
      >
        <X className="h-3 w-3 mr-1" />
        Clear all
      </Button>
    </div>
  );
};

export const TimelineActiveFilters = React.memo(TimelineActiveFiltersBase);
